module.exports = __webpack_public_path__ + "media/images/ui-cards/ui-cards-15-f6c72d95cc1b1e428f5f557b5b3b419c.jpg";